import { IEventBusTransport } from '../types';

export class EventBusStubTransport implements IEventBusTransport {
	public sendToServer(eventName: string, payload: unknown): void {
		console.log(`[EventBus] Trigger server ${eventName}, ${payload}`);
	}

	public sendToClient(eventName: string, payload: unknown): void {
		console.log(`[EventBus] Trigger client ${eventName}, ${payload}`);
	}
}
